var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 508,
    viewBox: "0 0 508 508",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.169 182.88C431.475 159.045 436.992 136.479 427.238 113.558C409.336 71.496 355.336 49.1643 313.375 69.0881C291.917 79.2481 273.568 94.1121 249.936 99.5681C186.152 114.29 87.7011 35.8547 52.9844 127.173C41.0667 158.506 45.8724 199.796 67.4218 225.989C74.3407 234.391 82.7938 241.706 87.9145 251.318C101.925 277.622 82.0928 306.527 73.152 331.064C51.9176 389.047 131.978 421.132 175.433 427.045C247.264 436.88 306.517 354.584 377.952 388.112C427.736 411.48 471.424 354.584 462.28 297.688C456.296 260.442 425.999 224.79 428.833 186.832C428.935 185.522 429.047 184.211 429.169 182.88Z",
    fill: "#35335E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M429.169 182.88C431.475 159.045 436.992 136.479 427.238 113.558C409.336 71.496 355.336 49.1643 313.375 69.0881C291.917 79.2481 273.568 94.1121 249.936 99.5681C186.152 114.29 87.7011 35.8547 52.9844 127.173C41.0667 158.506 45.8724 199.796 67.4218 225.989C74.3407 234.391 82.7938 241.706 87.9145 251.318C101.925 277.622 82.0928 306.527 73.152 331.064C51.9176 389.047 131.978 421.132 175.433 427.045C247.264 436.88 306.517 354.584 377.952 388.112C427.736 411.48 471.424 354.584 462.28 297.688C456.296 260.442 425.999 224.79 428.833 186.832C428.935 185.522 429.047 184.211 429.169 182.88Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1423 198.384C106.518 198.384 122.225 182.677 122.225 163.302C122.225 143.926 106.518 128.219 87.1423 128.219C67.7668 128.219 52.0598 143.926 52.0598 163.302C52.0598 182.677 67.7668 198.384 87.1423 198.384Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5312 194.899C103.907 194.899 119.614 179.192 119.614 159.817C119.614 140.441 103.907 124.734 84.5312 124.734C65.1557 124.734 49.4487 140.441 49.4487 159.817C49.4487 179.192 65.1557 194.899 84.5312 194.899Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5312 191.414C101.982 191.414 116.129 177.268 116.129 159.817C116.129 142.366 101.982 128.219 84.5312 128.219C67.0803 128.219 52.9336 142.366 52.9336 159.817C52.9336 177.268 67.0803 191.414 84.5312 191.414Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8228 136.063C80.8228 136.063 77.3379 127.345 71.2419 121.249C65.1459 115.153 40.2946 111.222 40.2946 111.222C44.3075 115.092 47.9567 119.323 51.1962 123.861C56.8554 131.704 75.5802 149.576 75.5802 149.576C75.5802 149.576 66.4362 141.732 58.1457 140.858C49.8551 139.985 28.9458 144.343 27.6657 144.343C26.3855 144.343 35.5092 147.828 42.0522 150.876C48.5953 153.924 73.8632 156.545 73.8632 156.545C73.8632 156.545 62.9717 159.593 55.5752 162.215C48.1787 164.836 41.1683 183.998 41.1683 183.998C41.1683 183.998 50.7594 175.28 59.0398 173.106C67.3202 170.932 79.0854 167.01 79.0854 167.01C79.0854 167.01 71.6788 175.291 69.9414 180.96C68.2041 186.629 69.5046 199.695 69.5046 199.695C69.5046 199.695 73.4263 187.503 78.2218 182.697C83.0174 177.891 88.2294 169.672 88.2294 169.672C90.6433 173.607 92.828 177.677 94.7725 181.864C98.2574 189.271 100.432 200.152 100.432 200.152C100.432 200.152 106.101 187.96 105.664 181.864C105.227 175.768 98.6942 164.866 98.6942 164.866C98.6942 164.866 103.053 161.818 109.586 164.429C116.119 167.041 127.457 177.942 127.457 177.942C127.457 177.942 124.836 163.556 120.477 157.897C116.119 152.237 97.3836 150.48 97.3836 150.48C97.3836 150.48 107.848 144.384 114.381 143.073C120.914 141.763 129.621 144.821 129.621 144.821C129.621 144.821 119.604 130.871 111.76 129.997C103.916 129.123 92.1512 141.295 92.1512 141.295L95.6462 123.861C96.5098 119.502 94.7725 108.621 94.7725 108.621C94.7725 108.621 89.977 111.232 84.3077 119.512C82.6485 121.897 81.4851 124.591 80.8865 127.434C80.2879 130.277 80.2662 133.211 80.8228 136.063Z",
    fill: "#35335E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.8228 136.063C80.8228 136.063 77.3379 127.345 71.2419 121.249C65.1459 115.153 40.2946 111.222 40.2946 111.222C44.3075 115.092 47.9567 119.323 51.1962 123.861C56.8554 131.704 75.5802 149.576 75.5802 149.576C75.5802 149.576 66.4362 141.732 58.1457 140.858C49.8551 139.985 28.9458 144.343 27.6657 144.343C26.3855 144.343 35.5092 147.828 42.0522 150.876C48.5953 153.924 73.8632 156.545 73.8632 156.545C73.8632 156.545 62.9717 159.593 55.5752 162.215C48.1787 164.836 41.1683 183.998 41.1683 183.998C41.1683 183.998 50.7594 175.28 59.0398 173.106C67.3202 170.932 79.0854 167.01 79.0854 167.01C79.0854 167.01 71.6788 175.291 69.9414 180.96C68.2041 186.629 69.5046 199.695 69.5046 199.695C69.5046 199.695 73.4263 187.503 78.2218 182.697C83.0174 177.891 88.2294 169.672 88.2294 169.672C90.6433 173.607 92.828 177.677 94.7725 181.864C98.2574 189.271 100.432 200.152 100.432 200.152C100.432 200.152 106.101 187.96 105.664 181.864C105.227 175.768 98.6942 164.866 98.6942 164.866C98.6942 164.866 103.053 161.818 109.586 164.429C116.119 167.041 127.457 177.942 127.457 177.942C127.457 177.942 124.836 163.556 120.477 157.897C116.119 152.237 97.3836 150.48 97.3836 150.48C97.3836 150.48 107.848 144.384 114.381 143.073C120.914 141.763 129.621 144.821 129.621 144.821C129.621 144.821 119.604 130.871 111.76 129.997C103.916 129.123 92.1512 141.295 92.1512 141.295L95.6462 123.861C96.5098 119.502 94.7725 108.621 94.7725 108.621C94.7725 108.621 89.977 111.232 84.3077 119.512C82.6485 121.897 81.4851 124.591 80.8865 127.434C80.2879 130.277 80.2662 133.211 80.8228 136.063Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.408 122.794C89.7128 121.544 90.0481 120.294 90.424 119.065",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2996 122.794C64.3636 125.771 69.4436 129.906 72.1055 133.452C76.901 139.984 86.4921 153.934 86.4921 153.934C86.2174 144.565 86.96 135.193 88.707 125.984",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2442 118.628C54.2442 118.628 55.5142 119.441 57.4142 120.752",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4921 153.934C86.4921 153.934 103.053 137.373 110.023 136.063C116.992 134.752 123.099 139.985 123.099 139.985",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.896 167.782C52.832 170.343 52.4967 171.846 52.4967 171.846",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.662 169.184C122.662 169.184 120.051 162.641 110.896 159.593C101.742 156.545 87.376 156.108 87.376 156.108C87.376 156.108 67.2084 162.712 59.8322 166.157",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5571 153.619C83.4339 155.042 87.3658 156.108 87.3658 156.108",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8638 145.877C52.5983 146.162 58.6943 146.812 62.0878 148.265C64.8513 149.454 70.297 151.171 75.438 152.705",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1683 145.654C41.1683 145.654 42.7634 145.654 45.1104 145.745",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4921 158.719C86.4921 158.719 74.3001 177.007 73.4162 181.386C72.8926 183.97 72.6001 186.595 72.5424 189.23",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9175 164.48C94.2645 167.528 97.0788 171.592 98.2574 174.843C99.6292 178.81 100.649 182.89 101.305 187.035",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2294 160.03C88.2294 160.03 89.2454 161.107 90.5561 162.763",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2856 139.822C75.2856 139.822 73.0402 130.678 74.4322 122.194C75.8241 113.711 93.7362 96.0018 93.7362 96.0018C92.7406 101.486 92.2475 107.05 92.263 112.624C92.263 122.296 87.437 147.737 87.437 147.737C87.437 147.737 90.2919 136.032 96.5098 130.465C102.728 124.897 122.265 116.241 123.322 115.499C124.379 114.757 118.984 122.906 115.458 129.205C111.933 135.504 92.903 152.4 92.903 152.4C92.903 152.4 103.53 148.519 111.069 146.304C118.608 144.089 135.453 155.611 135.453 155.611C135.453 155.611 122.58 154.127 114.584 157.185C106.589 160.244 94.742 163.921 94.742 163.921C94.742 163.921 105.593 166.329 110.307 169.916C115.021 173.502 121.605 184.912 121.605 184.912C121.605 184.912 111.303 177.282 104.607 176.185C97.9119 175.087 88.839 171.42 88.839 171.42C89.1832 176.022 89.7869 180.601 90.6475 185.136C92.141 193.192 96.7435 203.312 96.7435 203.312C96.7435 203.312 85.029 196.708 81.8185 191.496C78.6079 186.284 77.5716 173.624 77.5716 173.624C77.5716 173.624 72.2478 173.685 68.4276 179.619C64.6074 185.552 61.7931 201.016 61.7931 201.016C61.7931 201.016 55.5346 187.808 55.7682 180.696C56.0019 173.584 70.2056 161.209 70.2056 161.209C70.2056 161.209 58.1558 162.357 52.0802 165.1C46.0045 167.843 40.701 175.412 40.701 175.412C40.701 175.412 40.701 158.242 46.5734 152.959C52.4459 147.676 69.1185 150.724 69.1185 150.724L56.1137 138.603C52.8625 135.555 47.9247 125.7 47.9247 125.7C47.9247 125.7 53.3502 125.029 62.7786 128.453C65.5192 129.412 68.0387 130.913 70.1874 132.867C72.336 134.82 74.0698 137.185 75.2856 139.822Z",
    fill: "#35335E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5739 134.051C59.5579 133.208 58.6029 132.395 57.5869 131.602",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2162 117.074C82.6414 121.869 80.8838 128.179 80.8431 132.608C80.7618 140.736 81.1073 157.632 81.1073 157.632C75.8632 149.864 69.7889 142.689 62.992 136.235",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7156 110.155C86.7156 110.155 86.1466 111.557 85.3745 113.721",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1073 157.632C81.1073 157.632 57.9933 153.843 51.5722 156.85C45.151 159.857 43.241 167.64 43.241 167.64",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M113.233 151.618C117.998 151.354 119.136 152.319 119.136 152.319",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6247 191.12C60.6247 191.12 58.9382 184.282 64.5871 176.469C70.2361 168.656 81.6762 159.918 81.6762 159.918C81.6762 159.918 101.905 153.507 109.901 152.014",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.376 152.756C84.2467 156.749 81.6864 159.918 81.6864 159.918",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M107.787 128.565C104.11 131.613 99.5375 135.677 97.6274 138.796C96.073 141.376 92.649 145.908 89.3674 150.185",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M113.091 124.47C113.091 124.47 111.801 125.405 109.941 126.848",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9013 161.544C83.9013 161.544 104.496 169.286 107.737 172.324C109.669 174.116 111.437 176.078 113.02 178.186",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8548 169.367C82.7126 173.208 82.7837 178.135 83.7489 181.488C84.9466 185.516 86.5005 189.43 88.392 193.182",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.251 163.576C83.251 163.576 83.0885 165.019 82.9666 167.152",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M143.083 186.365H373.38C376.255 186.365 379.013 187.507 381.046 189.54C383.079 191.573 384.221 194.33 384.221 197.206V346.558C384.221 348.115 383.914 349.656 383.318 351.095C382.722 352.533 381.849 353.841 380.748 354.942C379.647 356.043 378.34 356.916 376.901 357.512C375.463 358.108 373.921 358.414 372.364 358.414H144.099C142.542 358.414 141 358.108 139.562 357.512C138.123 356.916 136.816 356.043 135.715 354.942C134.614 353.841 133.741 352.533 133.145 351.095C132.549 349.656 132.243 348.115 132.243 346.558V197.206C132.243 194.33 133.385 191.573 135.418 189.54C137.451 187.507 140.208 186.365 143.083 186.365Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M227.371 203.302H213.187V212.618H227.371V203.302Z",
    fill: "#2E353A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M181.417 260.777H168.25V273.842H181.417V260.777Z",
    fill: "#2E353A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M239.593 214.854H226.324V227.919H239.593V214.854Z",
    fill: "#2E353A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M210.942 203.302H196.759V212.618H210.942V203.302Z",
    fill: "#2E353A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M255.097 214.854H241.828V227.919H255.097V214.854Z",
    fill: "#2E353A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M243.789 203.302H229.606V212.618H243.789V203.302Z",
    fill: "#2E353A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.462 245.466H148.509V258.531H173.462V245.466Z",
    fill: "#2E353A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M208.575 214.854H195.306V227.919H208.575V214.854Z",
    fill: "#2E353A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M166.014 260.777H148.509V273.842H166.014V260.777Z",
    fill: "#2E353A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M260.218 203.302H246.035V212.618H260.218V203.302Z",
    fill: "#2E353A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M177.556 214.854H164.287V227.919H177.556V214.854Z",
    fill: "#2E353A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M178.095 203.302H163.911V212.618H178.095V203.302Z",
    fill: "#2E353A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M194.523 203.302H180.34V212.618H194.523V203.302Z",
    fill: "#2E353A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M193.06 214.854H179.791V227.919H193.06V214.854Z",
    fill: "#2E353A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M224.079 214.854H210.81V227.919H224.079V214.854Z",
    fill: "#2E353A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M325.923 203.302H311.739V212.618H325.923V203.302Z",
    fill: "#2E353A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M342.341 203.302H328.158V212.618H342.341V203.302Z",
    fill: "#2E353A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M332.649 214.854H319.38V227.919H332.649V214.854Z",
    fill: "#2E353A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M348.163 214.854H334.894V227.919H348.163V214.854Z",
    fill: "#2E353A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M372.699 260.777H353.162V273.842H372.699V260.777Z",
    fill: "#2E353A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M358.77 203.302H344.587V212.618H358.77V203.302Z",
    fill: "#2E353A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M162.052 214.854H148.509V227.919H162.052V214.854Z",
    fill: "#2E353A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M276.647 203.302H262.463V212.618H276.647V203.302Z",
    fill: "#2E353A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M293.065 203.302H278.882V212.618H293.065V203.302Z",
    fill: "#2E353A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M286.126 214.854H272.857V227.919H286.126V214.854Z",
    fill: "#2E353A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M317.144 214.854H303.875V227.919H317.144V214.854Z",
    fill: "#2E353A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M270.612 214.854H257.343V227.919H270.612V214.854Z",
    fill: "#2E353A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M301.63 214.854H288.361V227.919H301.63V214.854Z",
    fill: "#2E353A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M309.494 203.302H295.311V212.618H309.494V203.302Z",
    fill: "#2E353A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M289.286 260.777H276.118V273.842H289.286V260.777Z",
    fill: "#2E353A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M358.374 245.466H345.206V258.531H358.374V245.466Z",
    fill: "#2E353A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M342.961 245.466H329.794V258.531H342.961V245.466Z",
    fill: "#2E353A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M350.916 260.777H337.749V273.842H350.916V260.777Z",
    fill: "#2E353A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M335.514 260.777H322.346V273.842H335.514V260.777Z",
    fill: "#2E353A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M304.688 260.777H291.521V273.842H304.688V260.777Z",
    fill: "#2E353A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M320.101 260.777H306.934V273.842H320.101V260.777Z",
    fill: "#2E353A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M327.548 245.466H314.381V258.531H327.548V245.466Z",
    fill: "#2E353A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M312.146 245.466H298.978V258.531H312.146V245.466Z",
    fill: "#2E353A"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M372.709 203.302H361.015V212.618H372.709V203.302Z",
    fill: "#2E353A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M161.676 203.302H148.509V212.618H161.676V203.302Z",
    fill: "#2E353A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M372.709 276.078H148.509V289.662H372.709V276.078Z",
    fill: "#2E353A"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M372.699 214.854H350.398V227.919H372.699V214.854Z",
    fill: "#2E353A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M372.699 245.466H360.609V258.531H372.699V245.466Z",
    fill: "#2E353A"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M356.89 243.129H354.645V230.165H341.478V243.129H339.242V230.165H326.075V243.129H323.83V230.165H310.662V243.129H308.417V230.165H295.25V243.129H293.014V230.165H279.847V243.129H277.602V230.165H264.434V243.129H262.189V230.165H249.022V243.129H246.786V230.165H233.619V243.129H231.374V230.165H218.206V243.129H215.961V230.165H202.794V243.129H200.558V230.165H187.391V243.129H185.146V230.165H171.978V243.129H169.733V230.165H148.509V243.23H372.699V230.165H356.89V243.129Z",
    fill: "#2E353A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M250.505 245.466H237.338V258.531H250.505V245.466Z",
    fill: "#2E353A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M296.733 245.466H283.566V258.531H296.733V245.466Z",
    fill: "#2E353A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M219.69 245.466H206.522V258.531H219.69V245.466Z",
    fill: "#2E353A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M227.645 260.777H214.478V273.842H227.645V260.777Z",
    fill: "#2E353A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M235.092 245.466H221.925V258.531H235.092V245.466Z",
    fill: "#2E353A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M204.277 245.466H191.11V258.531H204.277V245.466Z",
    fill: "#2E353A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M196.83 260.777H183.662V273.842H196.83V260.777Z",
    fill: "#2E353A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M212.232 260.777H199.065V273.842H212.232V260.777Z",
    fill: "#2E353A"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M265.918 245.466H252.75V258.531H265.918V245.466Z",
    fill: "#2E353A"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M273.873 260.777H260.706V273.842H273.873V260.777Z",
    fill: "#2E353A"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M281.32 245.466H268.153V258.531H281.32V245.466Z",
    fill: "#2E353A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M243.058 260.777H229.89V273.842H243.058V260.777Z",
    fill: "#2E353A"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M258.46 260.777H245.293V273.842H258.46V260.777Z",
    fill: "#2E353A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M188.864 245.466H175.697V258.531H188.864V245.466Z",
    fill: "#2E353A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M398.607 92.8928H116.505C115.121 92.8939 113.757 93.2131 112.516 93.8258C111.276 94.4385 110.193 95.3282 109.351 96.4261C108.51 97.5241 107.932 98.8009 107.662 100.158C107.393 101.515 107.439 102.915 107.798 104.252L128.422 181.041C128.936 182.958 130.068 184.652 131.642 185.86C133.216 187.069 135.145 187.725 137.13 187.726H165.923V193.04H350.52V187.757H377.952C379.937 187.755 381.865 187.099 383.439 185.891C385.013 184.682 386.145 182.988 386.659 181.071L407.284 104.282C407.647 102.946 407.698 101.545 407.433 100.187C407.168 98.8279 406.594 97.5486 405.755 96.4475C404.916 95.3464 403.835 94.4531 402.596 93.8367C401.356 93.2203 399.991 92.8973 398.607 92.8928Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M366.705 180.949H148.407L126.573 102.382H388.529L366.705 180.949Z",
    fill: "#35335E",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M162.895 146.467V147.483H159.045V146.467H162.895Z",
    fill: "#2E353A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M167.691 146.467V147.483H163.83V146.467H167.691Z",
    fill: "#2E353A"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M172.486 146.467V147.483H168.656V146.467H172.486Z",
    fill: "#2E353A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M177.272 146.467V147.483H173.421V146.467H177.272Z",
    fill: "#2E353A"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M182.067 146.467V147.483H178.206V146.467H182.067Z",
    fill: "#2E353A"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M186.863 146.467V147.483H183.002V146.467H186.863Z",
    fill: "#2E353A"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M191.648 146.467V147.483H187.797V146.467H191.648Z",
    fill: "#2E353A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M196.393 151.821L192.146 140.503H193.162L197.409 151.821H196.393Z",
    fill: "#2E353A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M159.014 129.987V131.003H155.164V129.987H159.014Z",
    fill: "#2E353A"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M163.81 129.987V131.003H159.959V129.987H163.81Z",
    fill: "#2E353A"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M168.656 129.987V131.003H164.795V129.987H168.656Z",
    fill: "#2E353A"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M173.401 129.987V131.003H169.54V129.987H173.401Z",
    fill: "#2E353A"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M178.186 129.987V131.003H174.335V129.987H178.186Z",
    fill: "#2E353A"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M186.294 129.987V131.003H182.433V129.987H186.294Z",
    fill: "#2E353A"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M191.079 129.987V131.003H187.228V129.987H191.079Z",
    fill: "#2E353A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M195.875 129.987V131.003H192.024V129.987H195.875Z",
    fill: "#2E353A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M200.67 129.987V131.003H196.809V129.987H200.67Z",
    fill: "#2E353A"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M205.456 129.987V131.003H201.605V129.987H205.456Z",
    fill: "#2E353A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M210.251 129.987V131.003H206.4V129.987H210.251Z",
    fill: "#2E353A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M215.047 129.987V131.003H211.186V129.987H215.047Z",
    fill: "#2E353A"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M223.144 129.987V131.003H219.293V129.987H223.144Z",
    fill: "#2E353A"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M227.94 129.987V131.003H224.079V129.987H227.94Z",
    fill: "#2E353A"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M232.735 129.987V131.003H228.874V129.987H232.735Z",
    fill: "#2E353A"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M240.792 129.987V131.003H236.941V129.987H240.792Z",
    fill: "#2E353A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M245.628 129.987V131.003H241.808V129.987H245.628Z",
    fill: "#2E353A"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M250.424 129.987V131.003H246.563V129.987H250.424Z",
    fill: "#2E353A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M268.448 129.987V131.003H264.597V129.987H268.448Z",
    fill: "#2E353A"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M273.243 129.987V131.003H269.382V129.987H273.243Z",
    fill: "#2E353A"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M278.039 129.987V131.003H274.178V129.987H278.039Z",
    fill: "#2E353A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M282.824 129.987V131.003H278.973V129.987H282.824Z",
    fill: "#2E353A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M287.619 129.987V131.003H283.759V129.987H287.619Z",
    fill: "#2E353A"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M295.717 129.987V131.003H291.866V129.987H295.717Z",
    fill: "#2E353A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M300.512 129.987V131.003H296.672V129.987H300.512Z",
    fill: "#2E353A"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M305.308 129.987V131.003H301.447V129.987H305.308Z",
    fill: "#2E353A"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M313.406 129.987V131.003H309.555V129.987H313.406Z",
    fill: "#2E353A"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M321.513 129.987V131.003H317.652V129.987H321.513Z",
    fill: "#2E353A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M385.765 296.967L374.894 338.907L385.176 341.925L385.765 296.967Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M390.642 252.639C389.415 250.754 388.967 248.467 389.392 246.258C389.951 242.123 394.94 241.178 394.94 241.178C394.94 241.178 396.027 240.355 400.02 241.869C404.012 243.383 434.889 247.569 454.619 250.241C474.35 252.913 480.741 251.186 480.466 257.962C480.192 264.739 462.879 325.557 462.615 327.467C462.351 329.377 390.642 252.639 390.642 252.639Z",
    fill: "white",
    stroke: "#2E353A",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M473.633 263.892L390.633 252.641L377.221 351.578L460.221 362.829L473.633 263.892Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M458.206 283.627L463.032 284.287",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M427.98 279.532L454.386 283.119",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M395.976 275.194L424.16 279.014",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M450.647 291.562L461.843 293.086",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M394.787 283.992L439.196 290.007",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M417.322 296.001L460.654 301.874",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M393.588 292.781L412.862 295.402",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M431.719 306.913L459.456 310.673",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M408.178 303.713L428.539 306.476",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M392.4 301.579L404.673 303.246",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M448.34 318.12L458.267 319.461",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M391.211 310.378L441.665 317.216",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M429.016 324.449L457.078 328.259",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M390.012 319.166L424.241 323.809",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M437.683 334.589L455.879 337.048",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M400.782 329.58L433.233 333.98",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M388.823 327.965L396.961 329.062",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M473.639 263.896C473.639 263.896 475.061 250.099 480.141 255.646",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M445.496 370.18L445.404 378.948L440.294 371.734L419.781 302.738L424.983 301.183L445.496 370.18Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M422.947 304.132L420.108 304.959L440.264 374.064L443.102 373.236L422.947 304.132Z",
    fill: "#35335E",
    stroke: "#2E353A",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M445.496 370.2L440.304 371.744L445.404 378.948L445.496 370.2Z",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M442.854 375.341L445.404 378.948L445.455 374.569L442.854 375.341Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M420.086 294.234C419.397 294.441 418.819 294.911 418.476 295.543C418.133 296.175 418.055 296.917 418.257 297.607L419.781 302.738L424.983 301.193L423.459 296.062C423.252 295.374 422.781 294.796 422.149 294.453C421.517 294.11 420.775 294.032 420.086 294.234Z",
    fill: "white",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M420.086 294.234C419.397 294.441 418.819 294.911 418.476 295.543C418.133 296.175 418.055 296.917 418.257 297.607L418.988 300.055L424.18 298.511L423.459 296.062C423.252 295.374 422.781 294.796 422.149 294.453C421.517 294.11 420.775 294.032 420.086 294.234Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 253.482C163.586 254.396 162.946 255.351 162.306 256.357",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M174.864 241.249C172.033 243.873 169.414 246.717 167.03 249.753",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M163.332 246.644C160.556 250.537 158.041 254.61 155.804 258.836",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M234.991 268.986C234.351 269.9 233.7 270.855 233.06 271.851",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M245.618 256.753C242.792 259.379 240.177 262.223 237.795 265.257",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M234.097 262.128C231.322 266.044 228.807 270.137 226.568 274.381",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M336.408 243.84C335.483 243.21 334.508 242.58 333.502 241.95",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M348.803 254.284C346.131 251.501 343.247 248.93 340.177 246.593",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M343.235 242.824C339.282 240.109 335.155 237.655 330.881 235.478",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M231.902 306.832C231.374 310.652 230.581 315.976 229.789 319.136",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M232.491 302.189C232.491 302.189 232.41 302.91 232.258 304.079",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M235.204 313.03C234.095 316.73 232.737 320.352 231.14 323.87",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M286.004 318.445C286.004 318.445 286.685 327.254 291.419 331.998",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M285.323 327.254C285.323 327.254 287.355 333.35 291.419 336.062",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M147.32 374.335C147.32 374.335 151.831 370.708 151.831 339.527C151.831 308.346 157.023 285.567 163.424 275.58C169.824 265.593 175.809 261.589 178.613 261.589C181.417 261.589 179.405 265.186 175.412 270.378C171.42 275.57 167.823 278.374 166.218 284.775C164.612 291.175 164.622 299.161 166.624 298.359C168.626 297.556 171.816 281.574 174.61 275.58C177.404 269.585 184.211 261.986 188.204 258.389C192.197 254.792 200.995 244.003 204.988 246.797C208.981 249.591 206.593 253.594 204.196 255.189C201.798 256.784 192.197 266.365 187.808 272.379C183.418 278.394 180.614 293.563 183.012 293.959C185.41 294.355 192.603 271.983 196.596 267.188C200.589 262.392 216.581 249.194 220.177 248.798C223.774 248.402 224.18 253.99 220.98 256.794C217.78 259.598 206.99 271.577 203.393 278.77C199.796 285.963 198.191 299.161 201.361 295.961C204.531 292.76 209.753 279.573 214.152 275.173C218.552 270.774 231.739 256.794 234.94 258.389C238.14 259.984 237.338 263.987 234.544 266.781C231.75 269.575 220.95 284.775 218.156 292.76C215.362 300.746 212.151 323.139 213.756 319.949C215.362 316.758 220.553 300.36 223.347 293.533C226.141 286.705 231.739 283.545 232.542 286.735C233.345 289.926 231.739 291.531 229.738 298.734C227.736 305.938 227.706 325.15 221.752 335.9C215.798 346.649 191.902 369.651 188.712 377.637C186.401 383.137 183.642 388.438 180.462 393.487",
    fill: "#35335E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M369.367 377.038C369.367 377.038 364.744 370.708 364.744 339.527C364.744 308.346 359.542 285.567 353.151 275.58C346.761 265.593 340.756 261.589 337.962 261.589C335.168 261.589 337.16 265.186 341.163 270.378C345.166 275.57 348.752 278.374 350.307 284.775C351.861 291.175 351.912 299.161 349.91 298.359C347.909 297.556 344.719 281.574 341.914 275.58C339.11 269.585 332.323 261.986 328.331 258.389C324.338 254.792 315.539 244.003 311.536 246.797C307.533 249.591 309.941 253.594 312.339 255.189C314.736 256.784 324.327 266.365 328.727 272.379C333.126 278.394 335.92 293.563 333.522 293.959C331.125 294.355 323.962 271.983 319.969 267.208C315.976 262.433 299.974 249.215 296.377 248.818C292.781 248.422 292.384 254.01 295.585 256.814C298.785 259.618 309.575 271.597 313.172 278.79C316.768 285.984 318.364 299.181 315.204 295.981C312.044 292.781 306.812 279.593 302.423 275.194C298.033 270.794 284.836 256.814 281.635 258.409C278.435 260.005 279.237 264.008 282.031 266.802C284.825 269.596 295.626 284.795 298.42 292.781C301.214 300.766 304.414 323.159 302.819 319.969C301.224 316.779 296.022 300.38 293.228 293.553C290.434 286.725 284.836 283.566 284.033 286.756C283.23 289.946 284.836 291.551 286.827 298.755C288.818 305.958 288.859 325.171 294.823 335.92C300.787 346.669 324.002 367.65 327.203 375.646C330.403 383.642 336.194 396.24 336.194 396.24",
    fill: "#35335E"
  }))), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M145.796 382.016C145.796 382.016 151.79 362.438 151.79 331.216C151.79 299.994 156.982 277.256 163.383 267.269C169.784 257.282 175.768 253.279 178.572 253.279C181.376 253.279 179.365 256.875 175.372 262.067C171.379 267.259 167.782 270.063 166.177 276.454C164.572 282.844 164.582 290.85 166.583 290.048C168.585 289.245 171.775 273.263 174.569 267.269C177.363 261.274 184.17 253.675 188.163 250.078C192.156 246.482 200.955 235.692 204.948 238.486C208.94 241.28 206.553 245.283 204.155 246.878C201.757 248.473 192.156 258.054 187.767 264.068C183.378 270.083 180.574 285.252 182.971 285.648C185.369 286.045 192.563 263.672 196.555 258.867C200.548 254.061 216.54 240.883 220.137 240.487C223.733 240.091 224.14 245.679 220.939 248.483C217.739 251.287 206.949 263.266 203.352 270.459C199.756 277.652 198.15 290.85 201.32 287.65C204.49 284.449 209.713 271.262 214.112 266.862C218.511 262.463 231.699 248.483 234.899 250.078C238.1 251.673 237.297 255.676 234.503 258.47C231.709 261.264 220.909 276.454 218.115 284.449C215.321 292.445 212.11 314.828 213.716 311.627C215.321 308.427 220.513 292.049 223.307 285.211C226.101 278.374 231.699 275.214 232.501 278.414C233.304 281.615 231.699 283.21 229.697 290.403C227.696 297.596 227.665 316.819 221.712 327.579C215.758 338.338 192.532 367.548 189.332 375.544C186.131 383.54 178.938 401.127 178.938 401.127",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M145.796 382.016C145.796 382.016 151.79 362.438 151.79 331.216C151.79 299.994 156.982 277.256 163.383 267.269C169.784 257.282 175.768 253.279 178.572 253.279C181.376 253.279 179.365 256.875 175.372 262.067C171.379 267.259 167.782 270.063 166.177 276.454C164.572 282.844 164.582 290.85 166.583 290.048C168.585 289.245 171.775 273.263 174.569 267.269C177.363 261.274 184.17 253.675 188.163 250.078C192.156 246.482 200.955 235.692 204.948 238.486C208.94 241.28 206.553 245.283 204.155 246.878C201.757 248.473 192.156 258.054 187.767 264.068C183.378 270.083 180.574 285.252 182.971 285.648C185.369 286.045 192.563 263.672 196.555 258.867C200.548 254.061 216.54 240.883 220.137 240.487C223.733 240.091 224.14 245.679 220.939 248.483C217.739 251.287 206.949 263.266 203.352 270.459C199.756 277.652 198.15 290.85 201.32 287.65C204.49 284.449 209.713 271.262 214.112 266.862C218.511 262.463 231.699 248.483 234.899 250.078C238.1 251.673 237.297 255.676 234.503 258.47C231.709 261.264 220.909 276.454 218.115 284.449C215.321 292.445 212.11 314.828 213.716 311.627C215.321 308.427 220.513 292.049 223.307 285.211C226.101 278.374 231.699 275.214 232.501 278.414C233.304 281.615 231.699 283.21 229.697 290.403C227.696 297.596 227.665 316.819 221.712 327.579C215.758 338.338 192.532 367.548 189.332 375.544C186.131 383.54 178.938 401.127 178.938 401.127",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M370.728 382.016C370.728 382.016 364.734 362.438 364.734 331.216C364.734 299.994 359.532 277.256 353.141 267.269C346.751 257.282 340.746 253.279 337.952 253.279C335.158 253.279 337.149 256.875 341.152 262.067C345.156 267.259 348.742 270.063 350.296 276.454C351.851 282.844 351.902 290.85 349.9 290.048C347.899 289.245 344.708 273.263 341.904 267.269C339.1 261.274 332.313 253.675 328.32 250.078C324.328 246.482 315.529 235.692 311.526 238.486C307.523 241.28 309.931 245.283 312.329 246.878C314.726 248.473 324.317 258.054 328.717 264.068C333.116 270.083 335.91 285.252 333.512 285.648C331.114 286.045 323.921 263.672 319.928 258.867C315.935 254.061 299.933 240.883 296.337 240.487C292.74 240.091 292.344 245.679 295.544 248.483C298.745 251.287 309.535 263.266 313.131 270.459C316.728 277.652 318.323 290.85 315.163 287.65C312.003 284.449 306.771 271.262 302.382 266.862C297.993 262.463 284.795 248.483 281.595 250.078C278.394 251.673 279.197 255.676 281.991 258.47C284.785 261.264 295.585 276.454 298.379 284.449C301.173 292.445 304.373 314.828 302.778 311.627C301.183 308.427 295.981 292.049 293.187 285.211C290.393 278.374 284.795 275.214 283.992 278.414C283.19 281.615 284.795 283.21 286.786 290.403C288.778 297.596 288.818 316.819 294.782 327.579C300.746 338.338 323.962 367.548 327.162 375.544C330.363 383.54 337.556 401.127 337.556 401.127",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M370.728 382.016C370.728 382.016 364.734 362.438 364.734 331.216C364.734 299.994 359.532 277.256 353.141 267.269C346.751 257.282 340.746 253.279 337.952 253.279C335.158 253.279 337.149 256.875 341.152 262.067C345.156 267.259 348.742 270.063 350.296 276.454C351.851 282.844 351.902 290.85 349.9 290.048C347.899 289.245 344.708 273.263 341.904 267.269C339.1 261.274 332.313 253.675 328.32 250.078C324.328 246.482 315.529 235.692 311.526 238.486C307.523 241.28 309.931 245.283 312.329 246.878C314.726 248.473 324.317 258.054 328.717 264.068C333.116 270.083 335.91 285.252 333.512 285.648C331.114 286.045 323.921 263.672 319.928 258.867C315.935 254.061 299.933 240.883 296.337 240.487C292.74 240.091 292.344 245.679 295.544 248.483C298.745 251.287 309.535 263.266 313.131 270.459C316.728 277.652 318.323 290.85 315.163 287.65C312.003 284.449 306.771 271.262 302.382 266.862C297.993 262.463 284.795 248.483 281.595 250.078C278.394 251.673 279.197 255.676 281.991 258.47C284.785 261.264 295.585 276.454 298.379 284.449C301.173 292.445 304.373 314.828 302.778 311.627C301.183 308.427 295.981 292.049 293.187 285.211C290.393 278.374 284.795 275.214 283.992 278.414C283.19 281.615 284.795 283.21 286.786 290.403C288.778 297.596 288.818 316.819 294.782 327.579C300.746 338.338 323.962 367.548 327.162 375.544C330.363 383.54 337.556 401.127 337.556 401.127",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M120.498 442.976H181.458C182.25 439.928 183.246 436.514 184.506 432.816C189.301 418.45 204.826 400.487 204.826 400.487C193.699 390.688 180.624 383.354 166.461 378.968C143.093 371.775 125.984 373.888 125.984 373.888C129.134 386.874 129.48 400.382 127 413.512C123.952 428.305 121.92 437.662 120.498 442.976Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M334.67 442.976H398.008C395.976 437.713 391.587 426.283 387.198 414.853C381.203 399.288 383.601 378.338 381.203 378.338C378.805 378.338 351.871 376.54 338.704 380.726C325.537 384.912 310.561 396.89 310.561 396.89C317.34 404.767 323.168 413.415 327.924 422.656C330.981 429.134 333.246 435.956 334.67 442.976Z",
    fill: "#2E353A",
    stroke: "#2E353A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M158.577 386.283C158.14 384.556 151.638 387.157 151.638 387.157C151.638 387.157 153.812 378.927 150.348 378.927C146.883 378.927 146.446 385.023 146.446 385.023C146.446 385.023 139.944 382.432 139.944 386.324C139.944 390.215 144.272 390.144 144.272 390.144C144.272 390.144 139.07 396.646 142.972 397.937C146.873 399.227 149.464 394.472 149.464 394.472C149.464 394.472 152.065 398.81 155.56 397.073C159.055 395.336 156.423 391.444 156.423 391.444C156.423 391.444 159.004 388.02 158.577 386.283ZM149.911 392.785C149.584 392.713 149.284 392.549 149.046 392.313C148.808 392.078 148.641 391.779 148.565 391.453C148.489 391.127 148.507 390.786 148.616 390.469C148.726 390.152 148.923 389.873 149.184 389.663C149.445 389.454 149.76 389.322 150.093 389.284C150.426 389.245 150.763 389.302 151.065 389.446C151.367 389.591 151.622 389.818 151.801 390.102C151.98 390.385 152.075 390.713 152.075 391.048C152.002 391.558 151.737 392.021 151.336 392.344C150.934 392.666 150.425 392.824 149.911 392.785ZM168.107 434.848C167.67 433.121 161.168 435.722 161.168 435.722C161.168 435.722 163.342 427.492 159.868 427.492C156.393 427.492 155.976 433.588 155.976 433.588C155.976 433.588 149.474 430.987 149.474 434.878C149.474 438.77 153.812 438.78 153.812 438.78C153.812 438.78 148.61 445.282 152.512 446.583C156.413 447.883 159.004 443.108 159.004 443.108C159.004 443.108 161.605 447.446 165.1 445.709C168.595 443.972 165.964 440.08 165.964 440.08C165.964 440.08 168.534 436.534 168.107 434.848ZM159.441 441.35C159.114 441.278 158.814 441.114 158.576 440.878C158.338 440.642 158.171 440.344 158.095 440.018C158.019 439.692 158.037 439.351 158.147 439.034C158.256 438.717 158.453 438.438 158.714 438.228C158.975 438.018 159.29 437.887 159.623 437.848C159.956 437.81 160.293 437.866 160.595 438.011C160.897 438.156 161.152 438.383 161.331 438.666C161.51 438.95 161.605 439.278 161.605 439.613C161.532 440.119 161.265 440.577 160.862 440.891C160.459 441.206 159.95 441.352 159.441 441.299V441.35ZM129.977 441.35C129.54 439.613 123.048 442.214 123.048 442.214C123.048 442.214 125.212 433.984 121.747 433.984C118.283 433.984 117.846 440.08 117.846 440.08C117.846 440.08 111.343 437.479 111.343 441.381C111.343 445.282 115.682 445.282 115.682 445.282C115.682 445.282 110.48 451.774 114.381 453.075C118.283 454.375 120.874 449.61 120.874 449.61C120.874 449.61 123.474 453.939 126.97 452.211C130.465 450.484 127.843 446.583 127.843 446.583C127.843 446.583 130.414 443.027 129.987 441.299L129.977 441.35ZM121.31 447.843C120.983 447.77 120.683 447.606 120.445 447.369C120.206 447.133 120.04 446.835 119.964 446.508C119.889 446.181 119.907 445.839 120.017 445.523C120.128 445.206 120.325 444.927 120.587 444.717C120.85 444.508 121.166 444.377 121.499 444.34C121.832 444.303 122.169 444.361 122.471 444.507C122.773 444.653 123.028 444.882 123.205 445.166C123.383 445.451 123.476 445.78 123.474 446.115C123.399 446.618 123.133 447.072 122.732 447.384C122.331 447.696 121.826 447.842 121.321 447.792L121.31 447.843ZM177.19 407.558H181.955C185.42 407.558 187.584 411.46 187.584 411.46C180.228 413.573 177.201 407.507 177.201 407.507L177.19 407.558ZM172.425 441.35H177.19C180.655 441.35 182.819 445.252 182.819 445.252C175.463 447.365 172.436 441.299 172.436 441.299L172.425 441.35ZM130.851 434.848H135.616C139.08 434.848 141.244 438.749 141.244 438.749C133.878 440.863 130.851 434.848 130.851 434.848ZM153.883 404.276L156.667 408.147C158.699 410.972 156.779 414.995 156.779 414.995C150.724 410.23 153.883 404.226 153.883 404.226V404.276ZM130.048 417.22L132.222 412.984C133.817 409.936 138.267 409.753 138.267 409.753C136.774 417.291 130.048 417.22 130.048 417.22Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M362.6 394.513C362.163 392.785 355.661 395.386 355.661 395.386C355.661 395.386 357.835 387.157 354.371 387.157C350.906 387.157 350.469 393.253 350.469 393.253C350.469 393.253 343.967 390.662 343.967 394.553C343.967 398.445 348.305 398.455 348.305 398.455C348.305 398.455 343.103 404.957 347.005 406.258C350.906 407.558 353.497 402.783 353.497 402.783C353.497 402.783 356.098 407.121 359.593 405.384C363.088 403.647 360.456 399.755 360.456 399.755C360.456 399.755 363.027 396.24 362.6 394.513ZM353.934 401.015C353.607 400.942 353.307 400.779 353.069 400.543C352.831 400.307 352.664 400.009 352.588 399.683C352.512 399.356 352.53 399.015 352.639 398.699C352.749 398.382 352.946 398.103 353.207 397.893C353.468 397.683 353.783 397.552 354.116 397.513C354.449 397.475 354.786 397.531 355.088 397.676C355.39 397.821 355.645 398.048 355.824 398.331C356.003 398.615 356.098 398.943 356.098 399.278C356.037 399.793 355.775 400.264 355.371 400.589C354.966 400.914 354.45 401.067 353.934 401.015ZM382.951 428.305C382.524 426.568 376.022 429.168 376.022 429.168C376.022 429.168 378.186 420.939 374.721 420.939C371.257 420.939 370.83 427.035 370.83 427.035C370.83 427.035 364.327 424.434 364.327 428.335C364.327 432.237 368.656 432.237 368.656 432.237C368.656 432.237 363.464 438.729 367.365 440.03C371.267 441.33 373.858 436.565 373.858 436.565C373.858 436.565 376.458 440.893 379.954 439.166C383.449 437.439 380.817 433.537 380.817 433.537C380.817 433.537 383.388 430.032 382.951 428.305ZM374.294 434.848C373.967 434.775 373.667 434.611 373.429 434.375C373.19 434.139 373.024 433.84 372.948 433.513C372.873 433.186 372.891 432.845 373.001 432.528C373.112 432.211 373.309 431.932 373.571 431.723C373.834 431.513 374.15 431.383 374.483 431.345C374.816 431.308 375.153 431.366 375.455 431.512C375.757 431.658 376.012 431.887 376.189 432.172C376.367 432.456 376.46 432.785 376.458 433.121C376.395 433.634 376.133 434.102 375.728 434.425C375.324 434.748 374.809 434.9 374.294 434.848ZM361.3 441.35C360.863 439.613 354.371 442.214 354.371 442.214C354.371 442.214 356.535 433.984 353.07 433.984C349.606 433.984 349.169 440.08 349.169 440.08C349.169 440.08 342.666 437.479 342.666 441.381C342.666 445.282 347.005 445.282 347.005 445.282C347.005 445.282 341.803 451.774 345.704 453.075C349.606 454.375 352.196 449.61 352.196 449.61C352.196 449.61 354.797 453.939 358.292 452.211C361.787 450.484 359.166 446.583 359.166 446.583C359.166 446.583 361.696 443.027 361.3 441.3V441.35ZM352.633 447.843C352.306 447.77 352.006 447.606 351.767 447.369C351.529 447.133 351.363 446.835 351.287 446.508C351.212 446.181 351.23 445.839 351.34 445.523C351.45 445.206 351.648 444.927 351.91 444.717C352.172 444.508 352.489 444.377 352.822 444.34C353.155 444.303 353.492 444.361 353.794 444.507C354.096 444.653 354.351 444.882 354.528 445.166C354.706 445.451 354.799 445.78 354.797 446.115C354.722 446.62 354.454 447.075 354.051 447.387C353.648 447.7 353.14 447.844 352.633 447.792V447.843ZM381.224 415.788H385.989C389.453 415.788 391.617 419.689 391.617 419.689C384.251 421.802 381.224 415.737 381.224 415.737V415.788ZM330.109 440.436H334.874C338.338 440.436 340.502 444.327 340.502 444.327C333.136 446.501 330.109 440.436 330.109 440.436ZM357.906 412.496L360.69 416.367C362.722 419.191 360.802 423.215 360.802 423.215C354.747 418.46 357.906 412.496 357.906 412.496ZM386.08 436.717L388.854 440.588C390.886 443.403 388.965 447.436 388.965 447.436C382.91 442.712 386.08 436.717 386.08 436.717ZM334.03 425.45L336.205 421.213C337.8 418.165 342.301 417.982 342.301 417.982C340.797 425.521 334.02 425.45 334.02 425.45H334.03Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingImage);
export default __webpack_public_path__ + "static/media/Landing-image.dce11288.svg";
export { ForwardRef as ReactComponent };